module.exports = __webpack_public_path__ + "resources/rank_num_2.386e3dfa8f5e509d.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_num_2.png
// module id = 541
// module chunks = 0 1 2 3